import { Utility } from "../../utils";
import { Paths } from "../../constants";
import { JobPost, Resume } from ".";

export class CareerCenterHelper {
    public static jobDetailsLink(x: JobPost) {
        return Paths.CareerCenter.Job.Details + Utility.toSlug(x.title) + "-" + Utility.padText(x.id.toString(), "0", 6);
    }

    public static resumeDetailsLink(x: Resume) {
        return Paths.CareerCenter.Resume.Details + Utility.toSlug(x.title) + "-" + Utility.padText(x.id.toString(), "0", 6);
    }
}



// WEBPACK FOOTER //
// ./src/models/careerCenter/CareerCenterHelper.ts